import { z } from 'zod';
import { appleAppStoreInfoSchema } from './appUpdates/appUpdateNativePolicySchema';

export const APPLE_TEAM_TYPES = ['IN_HOUSE', 'COMPANY_OR_ORGANIZATION', 'INDIVIDUAL'] as const;
export const zAppleTeamType = z.literal(APPLE_TEAM_TYPES);
export type AppleTeamType = z.output<typeof zAppleTeamType>;

export const mobileAppConfigSchema = z.object({
  androidBundleId: z.string().describe('Android Bundle Id // Defaults to value of Bundle Id'),
  appleMerchantId: z
    .string()
    .nullable()
    .default(null)
    .describe('Apple Merchant Id // Required for iOS Apple Pay. Defaults to merchant.{{bundleId}}'),
  bannerImageStorageId: z.string().nullable().default(null),
  bannerImageStorageUrl: z.string().nullable().default(null),
  displayName: z.string().describe('Display Name // Show under app icon'),
  expoAppleAppSpecificPassword: z
    .string()
    .nullable()
    .default(null)
    .describe('Apple App Specific Password (encrypted)'),
  expoAppleAscIssuerId: z.string().describe('Apple App Store Connect Issuer ID // eas submit'),
  expoAppleAscKeyId: z.string().describe('Apple App Store Connect Key ID // eas submit'),
  expoAppleId: z.string().describe('Apple ID // email address'),
  expoApplePassword: z.string().nullable().default(null).describe('Apple ID Password (encrypted)'),
  expoAppleTeamId: z.string().describe('Apple Team ID'),
  expoAppleTeamType: zAppleTeamType.describe('Apple Team Type'),
  iconImageStorageId: z.string().nullable().default(null),
  iconImageStorageUrl: z.string().nullable().default(null),
  iosBundleId: z.string().describe('iOS Bundle Id // Defaults to reverse website domain'),

  /**
   * App version that trigger in app update banner to show on Android.
   * @deprecated Moved to `appUpdateNativePolicies` (the Android listing's `latestNativeVersion`).
   */
  targetNativeVersionAndroid: z.number().nullable().optional(),
  /**
   * App version that trigger in app update banner to show on iOS.
   * @deprecated Moved to `appUpdateNativePolicies` (the iOS listing's `latestNativeVersion`).
   */
  targetNativeVersionIos: z.number().nullable().optional(),
  /**
   * Whether to force update the app if the native app version is less then value of `androidAppVersion`.
   * @deprecated Moved to `appUpdateNativePolicies` (the Android listing's `minNativeVersion`).
   */
  isUpdateRequiredAndroid: z.boolean().optional(),
  /**
   * Whether to force update the app if the native app version is less then value of `iosAppVersion`.
   * @deprecated Moved to `appUpdateNativePolicies` (the iOS listing's `minNativeVersion`).
   */
  isUpdateRequiredIos: z.boolean().optional(),
  /**
   * The result of the lookupAppleAppStoreInfo action.
   * @deprecated Moved to `appUpdateNativePolicies` (the iOS listing's `appleAppStoreInfo`).
   */
  appleAppStoreInfo: appleAppStoreInfoSchema.nullable().optional(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  restaurantId: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type MobileAppConfig = z.output<typeof mobileAppConfigSchema>;

export const mobileAppConfigStrictSchema = mobileAppConfigSchema;

export const mobileAppConfigCvxSchema = mobileAppConfigSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  restaurantId: z.string(),
  updatedAt: z.number(),
});
export type MobileAppConfigCvx = z.output<typeof mobileAppConfigCvxSchema>;
